module.exports = __webpack_public_path__ + "img/logo-ailem-mini.0a9dfc4f.png";